import {getApiConfig} from '../../../../utilities/index';
import {loadingDialog_show} from "../../../../actions";
import {toggle_modal} from "../../../../actions/A_Popups";

export const getFabricatorCustomersAndEmployees = () => {
  return (dispatch, getState) => {
    const {auth, asCustomer} = getState();
    // dispatch(loadingDialog_show(true, 'Loading...', 'Please wait while customer data is loaded'));

    let fabricatorId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
    const {get} = getApiConfig(`public/fabricator-customer-employees/${fabricatorId}/`);

    return get()
      .then(response => {
        // dispatch(loadingDialog_show(false));
        return response
      })
      .catch(error => {
        dispatch(toggle_modal(true, error));
      })
  }
}

export const userRegister = ({assignQuote = false} = {}) => {
  return (dispatch, getState) => {
    const store = getState();
    const {auth, asCustomer} = store;
    const {userInfo} = store.assignQuoteState;
    dispatch(loadingDialog_show(true, 'Loading...', "Please wait while new user is registered"));

    const data = {
      email: userInfo.email,
      firstName: userInfo.firstName,
      phone: userInfo.phoneNumber,
      isNew: true,
      postal: userInfo.postal,
      salesPersonFullName: userInfo.salesPersonFullName,
      salesPersonEmail: userInfo.salesPersonEmail,
      fabricatorId: asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId,
      employeeId: +userInfo.employeeId,
      quoteRequestType: "RegularDesign",
      yesNoConsultationRequest: false,
      lastName: userInfo.lastName,
      address1: userInfo.address1,
      address2: userInfo.address2,
      preferredCommunicationMethod: userInfo.preferredCommunicationMethod,
      howDidYouHearAboutUs: userInfo.howDidYouHearAboutUs,
      phone2: userInfo.phone2,
    };
    if (assignQuote) {
      ["lastName", "phone2", "address1", "address2", "preferredCommunicationMethod", "howDidYouHearAboutUs"]
        .forEach((property) => {
          data[property] = userInfo[property] // new fields added in new assign quote popup
        })
    }
    const {post} = getApiConfig("Public/RegisterClient");

    return post(data)
      .then(response => {
        console.log("response", response);
        dispatch(loadingDialog_show(false));
        if (response.error) {
          dispatch(toggle_modal(true, response.error));
        }
        return response
      })
      .catch(error => {
        dispatch(loadingDialog_show(false));
        dispatch(toggle_modal(true, error));
      })
  }
}

export const getCustomerById = (customerId) => {
  return (dispatch) => {
    dispatch(loadingDialog_show(true, 'Loading...', 'Please wait while customer data is loaded'));
    const {get} = getApiConfig(`public/getCustomerData/${customerId}?format=json`);
    return get()
      .then(response => {
        dispatch(loadingDialog_show(false));
        return response
      })
      .catch(error => {
        dispatch(loadingDialog_show(false));
        dispatch(toggle_modal(true, error));
      })
  }
}

export const postCloneJob = (cloneData) => {
  return (dispatch, getState) => {
    const store = getState();
    const {auth, asCustomer} = store;
    dispatch(loadingDialog_show(true, "Loading...", "Please wait while job is created"));

    let fabricatorId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
    const {post} = getApiConfig(`public/copyJob/${fabricatorId}/`);

    return post(cloneData)
      .then(response => {
        dispatch(loadingDialog_show(false));
        return response
      })
      .catch(error => {
        dispatch(loadingDialog_show(false));
        dispatch(toggle_modal(true, error));
      })
  }
}
